import { makeArray } from '../../../../shared/utils/makeArray';
import type { FeatureLookupConfig } from './types/productProvisioning.types';

export class ProductProvisioningContextService {
  static checkFlag(flag: string | string[] | undefined, state?: Record<string, boolean> | null) {
    if (!state || !flag) {
      return false;
    }
    return makeArray(flag).some((flag) => !!state[flag]);
  }

  static buildFeatureConfig(name: string, { limit, exclude, included }: FeatureLookupConfig) {
    if (typeof limit === 'number' && limit < 1) {
      throw new Error(`Feature ${name} has an invalid limit: ${limit}`);
    }
    if (exclude && (!Array.isArray(exclude) || !exclude.length)) {
      throw new Error(`Feature ${name} has an invalid exclude: ${exclude}`);
    }
    if (included && (!Array.isArray(included) || !included.length)) {
      throw new Error(`Feature ${name} has an invalid included: ${included}`);
    }

    const config: FeatureLookupConfig = {};

    if (typeof limit === 'number') {
      config.limit = limit;
    }
    if (exclude) {
      config.exclude = exclude;
    }
    if (included) {
      config.included = included;
    }

    return Object.keys(config).length > 0 ? config : undefined;
  }

  static isBelowLimit(limit: number | undefined, current: number | undefined | null) {
    if (limit === undefined) {
      return true;
    }
    return typeof current === 'number' && current < limit;
  }

  static isIncluded(included: string[] | undefined, requested: string | undefined | null) {
    if (!included) {
      return true;
    }
    return !!requested && included.includes(requested);
  }

  static isExcluded(excluded: string[] | undefined, requested: string | undefined | null) {
    if (!excluded) {
      return false;
    }
    return !!requested && excluded.includes(requested);
  }
}
